import { withNamespace } from "@/i18n/lazy-route"

/** The wallet (LLD §9.8, Task 4.1), with the `wallet` namespace. */
export const WalletScreen = withNamespace("wallet", () => import("./screens/WalletScreen"), {
  en: () => import("@/i18n/locales/en/wallet.json"),
  fr: () => import("@/i18n/locales/fr/wallet.json"),
})
